
/**
 * Decodes the JWT Token into a JSON object
 * @remarks Source: https://stackoverflow.com/a/38552302
 * @param token The JWT token
 * @returns The JWT payload as JSON
 */
export function parseJwt(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}

export function getDecodedJwt(jwt: string) {
  if (jwt === null) {
    return null;
  }

  return parseJwt(jwt);
}

